import {
    getUniqFieldId,
} from 'app/common/DomainObject'
import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'

import {
    DailyOpsFields,
} from '../dailyOps.types'

const config: SkyNetTableConfig<DailyOpsFields> = {
    tabs: [{
        name: 'Air Transport By Customer: Info',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'orderNumber',
                filterField: 'orderNumber',
                filterType: FilterType.Array,
                width: '100px',
            },
            {
                name: 'from',
                filterField: 'from',
                filterType: FilterType.Array,
                width: '100px',
            },
            {
                name: 'to',
                filterField: 'to',
                filterType: FilterType.Array,
                width: '100px',
            },
            {
                name: 'customerLocationName',
                filterField: 'customerLocationName',
                filterType: FilterType.Array,
            },
            {
                name: 'consigneeLocationName',
                filterField: 'consigneeLocationName',
                filterType: FilterType.Array,
            },
            {
                name: 'mawbNumber',
                filterField: 'mawbNumber',
                filterType: FilterType.Array,
            },
            {
                name: 'estimatedDeliveryAir',
                filterField: 'estimatedDeliveryAir',
                filterType: FilterType.DateRange,
                componentName: 'DateTimeCell',
            },
            {
                name: 'estimatedDeliveryAir',
                id: getUniqFieldId('estimatedDeliveryAir', 1),
                componentName: 'ContainerSelectionUntil',
                headerProps: {
                    children: 'Remaining / Overdue',
                },
                sorting: false,
            },
        ],
    }],

}

export default config
